import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-notfound',
  standalone: true,
  // Ensure all necessary imports are here. Add AppFloatingConfigurator if needed.
  imports: [RouterModule, ButtonModule], 
  templateUrl: './notfound.html',
  styleUrls: ['./notfound.scss'],
})
// The class MUST be named 'Notfound' for the router to find it (m => m.Notfound)
export class Notfound {}
